"use client";
import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input";

function AppTextArea(props: TextAreaProps) {
  return <Input.TextArea {...props} />;
}

export { AppTextArea };
